import { render } from "./Docker.vue?vue&type=template&id=1cb38e68"
import script from "./Docker.vue?vue&type=script&lang=js"
export * from "./Docker.vue?vue&type=script&lang=js"

import "./Docker.vue?vue&type=style&index=0&id=1cb38e68&lang=scss"
script.render = render

export default script